// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
    <div style={{ textAlign: 'center', padding: '100px 20px' }}>
        <h1 style={{ fontSize: '80px', marginBottom: '20px' }}>404</h1>
        <h2 style={{ marginBottom: '20px' }}>Page Not Found</h2>
        <p>The page you are looking for doesn't exist or has been moved.</p>
        <Link to="/" style={{ color: '#0071ba', textDecoration: 'underline' }}>
            Go to Homepage
        </Link>
    </div>
);

export default NotFound;